<template>
  <div
    class="coupon-wrapper"
    :style="{ 'padding-bottom': show ? '.14rem' : '.28rem' }"
  >
    <div class="coupon">
      <div class="coupon-left">
        <div class="coupon-price">¥{{ detail.faceValue }}</div>
        <div class="coupon-use-limit">
          {{ detail.threshold }}
        </div>
      </div>
      <div class="coupon-right">
        <div class="title">
          {{ detail.mainTitle }}
        </div>
        <div class="title-sub">
          {{ detail.description }}
        </div>
        <div class="title-bot">
          <div class="title-bot-left">
            {{ detail.validDate }}
          </div>
          <div
            v-if="detail.detail"
            class="title-bot-btn"
            @click="handleCLickShow"
          >
            详情<i class="icon_arrow" :class="{ bottom: !show }" />
          </div>
        </div>
      </div>
      <div class="subscript">
        {{ detail.leftNum }}
      </div>
    </div>
    <div class="detail" :style="{ display: show ? 'block' : 'none' }">
      {{ detail.detail }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Coupon',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    handleCLickShow() {
      this.show = !this.show
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-wrapper {
  position: relative;
  margin: 0 auto;
  width: 6.86rem;
}
.coupon {
  position: relative;
  display: flex;
  width: 6.86rem;
  height: 2rem;
  z-index: 10;
  background-image: url('~@/images/couponPack/coupon.png');
  background-size: 100% 100%;
  box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.08);
  &-left {
    width: 1.76rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &-right {
    flex: 1;
    padding: 0.25rem 0.24rem 0;
    .title {
      font-size: 0.3rem;
      color: #333;
      line-height: 0.3rem;
      font-weight: 600;
    }
    .title-sub {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin-top: 0.1rem;
      overflow: hidden;
      font-size: 0.24rem;
      height: 0.68rem;
      line-height: 0.34rem;
      color: rgba(153, 153, 153, 0.9);
    }
    .title-bot {
      margin-top: 0.07rem;
      padding-top: 0.1rem;
      display: flex;
      justify-content: space-between;
      border-top: 1px dashed #ccc;
      font-size: 0.24rem;
      color: rgba(153, 153, 153, 0.9);
      .title-bot-btn {
        display: flex;
        align-items: center;
        .icon_arrow {
          margin-left: 0.05rem;
          width: 0.2rem;
          height: 0.2rem;
          background-image: url('~@/images/arrow/arrow.png');
          background-size: cover;
          &.bottom {
            transform: rotate(180deg);
          }
        }
      }
      .title-bot-left {
        font-size: 0.22rem;
        color: rgba(153, 153, 153, 0.9);
      }
    }
  }
  &-price {
    font-size: 0.56rem;
    color: #fff;
    font-weight: 600;
  }
  &-use-limit {
    font-size: 0.2rem;
    color: rgba(225, 225, 225, 0.7);
  }
  .subscript {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.68rem;
    height: 0.36rem;
    text-align: center;
    line-height: 0.36rem;
    color: #ff4a28;
    font-size: 0.24rem;
    border-radius: 0.08rem 0 0.2rem;
    background: #fff;
  }
}
.detail {
  padding: 0.3rem 0.2rem 0.24rem;
  z-index: -1;
  width: 100%;
  font-size: 0.2rem;
  border-radius: 0.12rem;
  color: #999;
  background-color: rgb(255, 255, 255);
  transform: translateY(-0.14rem);
  box-sizing: border-box;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.03);
  transition: all 0.5s ease-in;
}
</style>
